// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\nspan[data-v-bb7ceecc] {\n  background-color: var(--color-dark-blue);\n  border-radius: 5px;\n  border: none;\n  color: #fff;\n  display: inline-block;\n  font-weight: 600;\n  font-size: clamp(1rem, 0.6vw, 1.2rem);\n  padding: 0.3rem 0.6rem 0.4rem;\n  outline: none;\n  text-align: center;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
